module.exports = __webpack_public_path__ + "static/media/15pic.81b54073.jpg";